module.exports = __webpack_public_path__ + "static/Indonesia-bae4357a342584f7cc5b955de987622c.jpg";